import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { usePostOcrAccount } from "@/features/accounts/ocr/hooks/use-post-accounts";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
interface Props {
  onTapCloseModal: () => void;
  onTapAddNextModal: (ocrAccountId?: string) => void;
}

// 金融機関選択モーダル
export const AddOcrAccountsModal = (props: Props) => {
  const {
    onTapCloseModal,
    onTapAddNextModal,
  } = props;

  const {
    passbookName,
    onPassbookName,
    registerOcrAccounts,
  } = usePostOcrAccount();

  const {
    selectedAccountGroup,
  } = useAccountGroupsContext();

  // 次へボタン押下時処理
  const handleRegister = async () => {
    const ocrAccountId = await registerOcrAccounts(selectedAccountGroup.accountGroupId, passbookName.slice(0, 50).trim());
    // モーダルを閉じる
    if (ocrAccountId) {
      onTapAddNextModal(ocrAccountId);
    }
    // onTapCloseModal();
  };

  return (
    <BasePageModal
      title="通帳OCR用Web明細帳を作成"
      className="md-new-ocr"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="次へ"
          className="open-modal"
          onClick={handleRegister}
          id="action"
          isActive={passbookName !== undefined && passbookName !== ""}
        />
      }
      disableOverlayClose={true}
    >
      <h2>Web明細帳名を設定してください</h2>
      <dl>
        <SimpleForm
          onChange={onPassbookName}
          title="Web明細帳名"
          id="csvName"
          placeholder="Web明細帳名を入力（必須）"
          initialValue={passbookName}
          descriptionType={true}
          labelEnable={true}
        />
      </dl>
      <p>通帳OCR用Web明細帳では、スキャナなどで取り込んだ通帳の画像、もしくはカメラで撮影した通帳の画像から、文字情報を読み取って明細を作成します。</p>
    </BasePageModal>
  );
};